// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2x7v6","large":"styles_large__2ZN2r"};